import { DateFormatter } from '@repo/toolkit/date'
import { differenceInDays, differenceInMonths, differenceInYears } from 'date-fns'

type Options = {
  includeStartAndEndDays?: boolean
}

export function getReadableDuration(
  start: Date,
  end: Date,
  { includeStartAndEndDays }: Options = { includeStartAndEndDays: false }
): string {
  const totalDays = !includeStartAndEndDays
    ? differenceInDays(end, start)
    : DateFormatter.getDurationInDays(start, end)

  const years = differenceInYears(end, start)
  if (years >= 1) return `${years} ${years > 1 ? 'ans' : 'an'}`

  const months = differenceInMonths(end, start)
  if (months >= 1) return `${months} mois` // "mois" is the same in singular/plural

  if (totalDays >= 14 && totalDays % 7 === 0) {
    const weeks = totalDays / 7
    return `${weeks} ${weeks > 1 ? 'semaines' : 'semaine'}`
  }

  return `${totalDays} ${totalDays > 1 ? 'jours' : 'jour'}`
}
